// @/shared/jsonapiAdapter.ts
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * Converte um item JSON:API para objeto simples
 * Mescla attributes e relationships em um único objeto
 */
export var parseItem = function (item) {
    if (!item)
        return {};
    if (!item.attributes)
        return item;
    var parsed = __assign({ id: item.id }, item.attributes);
    // Processa relationships (mantém apenas os IDs)
    if (item.relationships) {
        Object.entries(item.relationships).forEach(function (_a) {
            var key = _a[0], rel = _a[1];
            var camelKey = key.replace(/_/g, '');
            camelKey = camelKey.charAt(0).toUpperCase() + camelKey.slice(1);
            if (rel.data === null) {
                parsed[camelKey] = null;
            }
            else if (Array.isArray(rel.data)) {
                parsed[camelKey] = rel.data.map(function (r) { return r.id; });
            }
            else {
                parsed[camelKey] = rel.data.id;
            }
        });
    }
    return parsed;
};
/**
 * Converte lista de itens JSON:API
 */
export var parseCollection = function (items) {
    return items.map(parseItem);
};
/**
 * Parser completo de resposta JSON:API
 * Converte para o formato ApiResponse padrão
 */
export var parseJsonApiResponse = function (response, itemParser) {
    var _a;
    var isArray = Array.isArray(response.data);
    var parsedData;
    if (isArray) {
        parsedData = parseCollection(response.data);
    }
    else {
        parsedData = parseItem(response.data);
    }
    // Aplica parser customizado se fornecido
    if (itemParser) {
        parsedData = isArray
            ? parsedData.map(itemParser)
            : itemParser(parsedData);
    }
    // Extrai paginação do meta
    var pagination = (_a = response.meta) === null || _a === void 0 ? void 0 : _a.pagination;
    return {
        data: parsedData,
        pagination: pagination,
        links: response.links,
        meta: response.meta,
    };
};
